;
(function(){
  var btn = document.getElementById('se-sticky-btn');
  var priceBlock = document.getElementById('se-sticky-price');
  var product = document.getElementById('se-product');
  if(!btn || !priceBlock || !product) return;
  var swapped = false;
  function onScroll(){
    var productBottom = product.getBoundingClientRect().bottom;
    if(!swapped && productBottom < window.innerHeight * 0.5){
      btn.innerHTML = 'See the Olivia &rarr;';
      btn.setAttribute('href', '/products/olivia-queen-murphy-cabinet-bed-with-mattress');
      priceBlock.style.display = 'flex';
      swapped = true;
    } else if(swapped && productBottom >= window.innerHeight * 0.5){
      btn.textContent = 'See the Solution →';
      btn.setAttribute('href', '#se-product');
      priceBlock.style.display = 'none';
      swapped = false;
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
